import { Add, Delete } from "@mui/icons-material"
import { Box, IconButton, Link } from "@mui/material"
import { MaterialReactTable, MRT_ToggleGlobalFilterButton, useMaterialReactTable } from "material-react-table"
import { MRT_Localization_RU } from "material-react-table/locales/ru"
import { useState } from "react"
import AlertDialog from "../../components/AlertDialog"
import { dialogModes, dialogTypes } from "../../constants"
import useDialogProps from "../../hooks/useDialogProps"
import { usePlans } from "../../redux/plansSlice"
import PlanForm from "./PlanForm"


const PlansPage = () => {

    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 50,
    });

    const { dialogData, dialogMode, dialogType, dialogIsOpen, openDialog, closeDialog } = useDialogProps()

    const editDialogIsOpen = dialogIsOpen && dialogType === dialogTypes.PLAN && dialogMode !== dialogModes.DELETE
    const deleteDialogIsOpen = dialogIsOpen && dialogType === dialogTypes.PLAN && dialogMode === dialogModes.DELETE

    const { plans, isLoading, total, handleCreatePlan, handleUpdatePlan, handleDeletePlan } = usePlans(pagination.pageIndex, pagination.pageSize)

    const table = useMaterialReactTable({
        data: plans,
        rowCount: total,
        state: {
            isSaving: isLoading,
            density: "compact",
            pagination
        },
        manualPagination: true,
        onPaginationChange: setPagination,
        localization: MRT_Localization_RU,
        columns: [
            { id: "name", accessorKey: "name", header: "Название", size: 200 },
            {
                id: "create_at",
                // accessorKey: "create_at",
                accessorFn: cell => new Date(cell.create_at).toLocaleString(),
                header: "Дата создания",
                size: 200,
            },
            {
                id: "file",
                accessorKey: "file",
                header: "Файл",
                Cell: ({ cell }) => <Link href={cell.getValue()} target="_blank">Скачать</Link>,
                size: 200,
            }
        ],
        enableRowActions: true,
        enableColumnFilters: false,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        enableSorting: false,
        enableHiding: false,
        enableStickyHeader: true,
        enableColumnActions: false,
        positionActionsColumn: "last",
        enableTopToolbar: true,
        renderToolbarInternalActions: ({ table }) => <Box sx={{ width: "100%" }}>
            {/* eslint-disable-next-line react/jsx-pascal-case */}
            <MRT_ToggleGlobalFilterButton table={table} />
            <IconButton onClick={() => openDialog({ dialogData: { name: "", file: null }, dialogMode: dialogModes.CREATE, dialogType: dialogTypes.PLAN })}>
                <Add />
            </IconButton>
        </Box>,
        renderRowActions: ({ row }) => <>
            {/* <IconButton
                onClick={() => openDialog({ dialogData: row.original, dialogMode: dialogModes.UPDATE, dialogType: dialogTypes.PLAN })}
            >
                <Edit />
            </IconButton> */}
            <IconButton onClick={() => openDialog({ dialogData: row.original, dialogMode: dialogModes.DELETE, dialogType: dialogTypes.PLAN })}>
                <Delete color="error" />
            </IconButton>
        </>,
        mrtTheme: { baseBackgroundColor: "#FFF" },
        muiTableContainerProps: {
            sx: {
                minHeight: "calc(100% - 115px)",
                maxHeight: "calc(100% - 115px)",
            }
        },
        muiTablePaperProps: { sx: { width: "100%", height: "100%", zIndex: 2 } }
    })


    return <Box sx={{ minWidth: 1200, width: "100%", height: "100%" }}>

        <MaterialReactTable table={table} />

        <PlanForm
            data={dialogData}
            open={editDialogIsOpen}
            mode={dialogMode}
            onClose={closeDialog}
            onSubmit={values => {
                if (dialogMode === dialogModes.CREATE) handleCreatePlan(values).then(closeDialog)
                if (dialogMode === dialogModes.UPDATE) handleUpdatePlan(values).then(closeDialog)
            }}
        />

        <AlertDialog
            title="Уаление плана"
            description="Вы уверены, что хотите удалить план?"
            open={deleteDialogIsOpen}
            onCancel={closeDialog}
            onOk={() => handleDeletePlan(dialogData).then(closeDialog)}

        />
    </Box>
}

export default PlansPage